export default __webpack_public_path__ + "static/media/Hassan El Mghari.2358e865.png";